<template>
  <Content>
    <div class="md-layout"/>
    <div class="btn-request-contador">
      <md-button
        class="md-raised md-primary"
        @click="requestAccountant">Cadastrar contador
      </md-button>
    </div>

    <md-table
      v-model="accountantFiltred"
      md-sort="name"
      md-fixed-header
      class="md-card-requestsclient"
      @md-selected="onSelect">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <label class="title-card-requests">Solicitações de acesso ao Minhas Notas</label>
        </div>

        <md-field
          md-clearable
          class="md-toolbar-section-end">
          <md-input
            v-model="search"
            placeholder="Pesquise pela nome da empresa..."
            @input="searchOnTable" />
        </md-field>
      </md-table-toolbar>

      <md-table-empty-state
        :md-description="`Nenhuma solicitação encontrada`">
        <div
          class="loading-request-accountant"
          align="center"/>
      </md-table-empty-state>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        md-selectable="single">
        <md-table-cell md-label="Nome Fantasia" md-sort-by="accountant.name">{{ item.accountant.name }}</md-table-cell>
        <md-table-cell
          v-if="item.accountant.identification.length === 14"
          md-sort-by="accountant.identification"
          md-label="CNPJ/CPF">{{ item.accountant.identification | mask('##.###.###/####-##') }}</md-table-cell>
        <md-table-cell
          v-else
          md-sort-by="accountant.identification"
          md-label="CNPJ/CPF">{{ item.accountant.identification | mask('###.###.###-##') }}</md-table-cell>
        <md-table-cell
          v-if="item.accessAllowed === false"
          md-sort-by="sortableAccessAllowed"
          md-label="Situação"><label class="label-false">Aguardando aprovação</label></md-table-cell>
        <md-table-cell
          v-else
          md-sort-by="sortableAccessAllowed"
          md-label="Situação"><label class="label-true">Aprovado</label></md-table-cell>
        <md-table-cell md-label="Data da Solicitação" md-sort-by="created">{{ formatDate(item.created) }}</md-table-cell>
        <md-table-cell
          v-if="item.accessAllowed === true"
          md-label="Ações"
          class="button-access"
          md-numeric>
          <md-table-row>
            <div class="button-pointer" @click="changeRequest(item)">
              <md-icon>close</md-icon>
            </div>
            <md-tooltip md-direction="bottom">Recusar solicitação</md-tooltip>
          </md-table-row>
          <md-table-row class="button-pointer" @click="deleteRequest(item.id)">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="bottom">Remover</md-tooltip>
          </md-table-row>
        </md-table-cell>
        <md-table-cell
          v-else
          md-label="Ações"
          class="button-access"
          md-numeric>
          <md-table-row>
            <div class="button-pointer" @click="changeRequest(item)">
              <md-icon>check</md-icon>
            </div>
            <md-tooltip md-direction="bottom">Aceitar solicitação</md-tooltip>
          </md-table-row>
          <md-table-row class="button-pointer" @click="deleteRequest(item.id)">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="bottom">Remover</md-tooltip>
          </md-table-row>
        </md-table-cell>
      </md-table-row>
    </md-table>

  </Content>
</template>
<script>
import Spinner from 'vue-spinkit';
import moment from 'moment';
import { http } from '../../public/api/backend';
import Content from '../public/Content.vue';

const toLower = text => text.toString().toLowerCase()

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.accountant.name).includes(toLower(term)))
  }

  return items
}

export default {
  name: 'RequestsClient',
  components: {
    Content,
    Spinner,
    moment
  },
  data() {
    return {
      client: [],
      selected: [],
      selectedRequest: {},
      customerIdentification: '',
      accountantFiltred: [],
      search: null,
    };
  },
  created() {
    this.getClient()
    this.filterAccountant()
  },
  methods: {

    onSelect(item) {
      this.selectedRequest = item
    },

    searchOnTable() {
      this.accountantFiltred = searchByName(this.selected, this.search)
    },

    getClient() {
      http.post('application.get-client').then(response => {
        this.client = response.data
      })
    },

    deleteRequest(id) {
      this.loadingSearch = true
      swal({
        title: 'Tem certeza que deseja excluir?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false,
          }
        },
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading();
            return swal.close();
          }
          this.postDeleteRequest(id);
        });
    },

    postDeleteRequest(id) {
      http.post('clipp.delete-request', {
        id,
      })
        .then(() => {
          this.$toasted.show('Registro removido com sucesso!', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle',
          });
          swal.stopLoading()
          swal.close()
          this.filterAccountant()
        })
    },

    requestClient() {
      this.loadingSearch = true
      swal({
        title: 'Informe o CNPJ da empresa que deseja solicitar o acesso as informações.',
        text: 'Lembrando que a empresa, deverá autorizar o acesso pelo MinhasNotas.',
        icon: 'warning',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Informe o CNPJ',
          }
        },
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading()
            swal.close()
            return
          }
          this.postRequestClient(value)
        });
    },

    postRequestClient(value) {
      http.post('clipp.request-access-to-client', {
        identification: this.cleanIdentification(value),
      })
        .then(() => {
          this.$toasted.show('Solicitação enviada com sucesso.', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle'
          });
          swal.stopLoading()
          swal.close()
          this.filterClient()
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'error',
            icon: 'error_outline'
          });
          swal.stopLoading()
          swal.close()
        });
    },


    changeRequest(item) {
      if (item.accessAllowed === false) {
        this.updateAceptRequest(item.accessAllowed)
        return
      }
      this.updateDenyRequest(item.accessAllowed)
    },

    updateAceptRequest(accessAllowed) {
      swal({
        title: 'Deseja aceitar a solicitação?',
        text: 'Com isso seu contador terá acesso as informações.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      })
        .then((selectedRequest) => {
          if (!selectedRequest) {
            swal.close()
            return
          }
          this.updateRequestAccountant(accessAllowed)
          swal('Solicitação aceita com sucesso', {
            icon: 'success',
          });
        });
    },

    updateDenyRequest(accessAllowed) {
      swal({
        title: 'Deseja recusar o acesso?',
        text: 'Com isso seu contador não irá mais acessar suas informações.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      })
        .then((selectedRequest) => {
          if (!selectedRequest) {
            swal.close()
            return
          }
          this.updateRequestAccountant(accessAllowed)
          swal('Solicitação aceita com sucesso', {
            icon: 'success',
          });
        });
    },

    updateRequestAccountant(accessAllowed) {
      const data = {
        id: this.selectedRequest.id,
        accessAllowed: !accessAllowed,
        origin: process.env.SERVER
      }
      http.post('clipp.accept-accountant-access', data)
        .then(response => {
          this.filterAccountant()
        })
    },

    filterAccountant() {
      http.post('clipp.get-client-access-request')
        .then(response => {
          this.accountantFiltred = response.data.requests
          this.selected = response.data.requests
        })
    },

    requestAccountant() {
      swal({
        title: 'Informe o CNPJ do seu contador',
        text: 'Após este procedimento o mesmo terá acesso aos seus documentos fiscais',
        icon: 'warning',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Informe o CNPJ',
          }
        },
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading()
            swal.close()
            return
          }
          this.postRequestAccountant(value)
        });
    },


    modalNewAccoutant() {
      swal({
        title: 'Não foi localizado nenhum cadastro com o CNPJ informado.',
        text: 'Informe o e-mail do seu contador para que possamos enviar o formulário de cadastro.',
        icon: 'warning',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Informe o e-mail',
          }
        },
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading()
            swal.close()
            return
          }
          this.sendMailAccountant(value)
        });
    },

    postRequestAccountant(value) {
      http.post('clipp.request-access-to-client', {
        identification: this.cleanIdentification(value),
      })
        .then(() => {
          this.$toasted.show('Solicitação enviada com sucesso, aguarde a autorização do cliente.', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle'
          });
          swal.stopLoading()
          swal.close()
          this.postRequestClient(value)
        })
        .catch(error => {
          swal.stopLoading()
          swal.close()
          this.modalNewAccoutant()
        });
    },

    postRequestClient(value) {
      http.post('clipp.request-access-to-client', {
        identification: this.cleanIdentification(this.client.identification),
        accountant: this.cleanIdentification(value)
      })
        .then(response => {
          this.updateIdRequestAccountant(response.data.id)
        });
    },

    updateIdRequestAccountant(value) {
      http.post('clipp.accept-accountant-access', {
        id: value,
        accessAllowed: true,
        origin: process.env.SERVER,
      })
        .then(response => {
          this.filterAccountant()
        })
    },

    sendMailAccountant(value) {
      http.post('clipp.send-sigup-email', {
        email: value,
        origin: process.env.SERVER,
      })
      swal.stopLoading()
      swal.close()
      this.$toasted.show('E-mail enviado com sucesso. Seu contador vai receber as instruções para realizar o cadastro', {
        theme: 'outline',
        position: 'bottom-right',
        duration: 5000,
        type: 'success',
        icon: 'check_circle'
      });
    },

    formatDate(value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    },

    cleanIdentification(value) {
      return value.replace(/\^|~|\?|,|\*|\.|-|\/|/g, '');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/client/requests/RequestsClient.vue